const pageURLParameter = window.location.pathname;

// FUNCTION TO CONTROL HEADER/FOOTER FIXED
export function showPartialsFixed(partial, partialShow, partialHide) {
  const partialSelected = document.querySelectorAll(partial);
  const parameters = ['/consorcio', '/test-drive', '/condicoes-mensais', '/politica-de-cookies', '/novos', '/seminovos',
    '/politica-de-privacidade', '/contato', '/institucional', '/correspondente-bancario', '/condicoes', '/despachante', '/trabalhe-conosco'];

  partialSelected.forEach((partial) => {

    if (window.innerWidth >= 992) {
      if (parameters.includes(pageURLParameter)) {

        if (window.scrollY > 120) {
          partial.classList.add(partialShow);
          partial.classList.remove(partialHide);

        } else {
          if (partial.classList.contains(partialShow)) {
            partial.classList.add(partialHide);
            partial.classList.remove(partialShow);
          }
        }

      } else {

        if (window.scrollY > 700) {
          partial.classList.add(partialShow);
          partial.classList.remove(partialHide);
        } else {
          if (partial.classList.contains(partialShow)) {
            partial.classList.add(partialHide);
            partial.classList.remove(partialShow);
          }
        }
      }

    } else {

      if (window.scrollY > 150) {
        partial.classList.add(partialShow);
        partial.classList.remove(partialHide);

      } else {

        if (partial.classList.contains(partialShow)) {
          partial.classList.add(partialHide);
          partial.classList.remove(partialShow);
        }
      }
    }
  });
}
